import React from "react";
import { Stack, Typography } from "@mui/material";

import { PagePrint } from "../PagePrint";
import { TERMS_LIST } from "../../constants/terms";
import TermsPage from "./TermsPage";
import { PageMarker } from "../PageMarker";

const rows = 8;

export const VendorTerms = ({ pageStart = 1, totalPages = 3 }) => {
  const pages = [TERMS_LIST.slice(0, 8), TERMS_LIST.slice(8)];
  return (
    <>
      {pages?.map((terms, i) => (
        <PagePrint
          cardProps={{
            id: `page-${i + pageStart + 1}`,
            sx: { position: "relative" },
          }}
        >
          <TermsPage>
            <Stack zIndex={1} mt="59px" p="72px" gap="12px">
              <Typography
                variant="boldCaptionL"
                color="hubColors.black"
                textAlign="center"
                fontSize={20}
              >
                Purchase Order Terms & Conditions
              </Typography>
              {terms?.map((t, idx) => (
                <Stack>
                  <Typography
                    variant="boldCaptionL"
                    fontSize={16}
                    color="hubColors.black"
                  >
                    {idx + 1 + rows * i}. {t.title}
                  </Typography>
                  <Typography
                    variant="caption"
                    fontSize={14}
                    color="hubColors.black"
                    lineHeight="16px"
                  >
                    {t.label}
                  </Typography>
                </Stack>
              ))}
            </Stack>
            <PageMarker page={pageStart + i + 1} pages={totalPages} />
          </TermsPage>
        </PagePrint>
      ))}
    </>
  );
};

export default VendorTerms;
